"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessageArchived = exports.INBOX_MARK_MESSAGE_ARCHIVED = void 0;
var INBOX_MARK_MESSAGE_ARCHIVED = "inbox/MARK_MESSAGE_ARCHIVED";
exports.INBOX_MARK_MESSAGE_ARCHIVED = INBOX_MARK_MESSAGE_ARCHIVED;

var markMessageArchived = function markMessageArchived(messageId) {
  return {
    type: INBOX_MARK_MESSAGE_ARCHIVED,
    payload: {
      messageId: messageId
    }
  };
};

exports.markMessageArchived = markMessageArchived;